import { createContext, useContext, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import InstituteSelectionModal from './InstituteSelectionModal'

const AuthContext = createContext()
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [isLoginSuccessfull, setIsLoginSuccessful] = useState(false)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [students, setStudents] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('🔍 Checking if user is logged in:', userLogged)

    if (userLogged) {
      try {
        const parsedUser = JSON.parse(userLogged)
        if (parsedUser?.token && parsedUser?.user_type) {
          setUser(parsedUser)
          console.log('✅ User restored from cookies:', parsedUser)
        } else {
          Cookies.remove('user')
          console.log('❌ Invalid cookie data removed')
        }
      } catch (error) {
        Cookies.remove('user')
        console.error('❌ Error parsing user from cookies:', error)

        // setUser(null)
      }
    }
    setLoading(false)
  }, [])

  // const login = async (loginData) => {
  //   console.log('📤 Login request sent:', loginData)

  //   try {
  //     const response = await ApiEndpoints.login(loginData)
  //     const result = response?.data?.result
  //     console.log('📥 Login response received:', result)

  //     // Check if login was successful
  //     if (!result || result === 'User not found') {
  //       toast.error(response.data.message || 'Login failed')
  //       return
  //     }

  //     // Extract token and user type
  //     const { token, user_type, institute_id } = result

  //     // Store user information in state and cookies
  //     const userData = { token, user_type, } // Correctly structured object
  //     Cookies.set('user', JSON.stringify(userData))
  //     setUser(userData)

  //     toast.success(`${response.data.message}.`)

  //     if (user_type === 'admin') {
  //       // toast.success(' Please select an institute.')
  //       setIsLoginSuccessful(true)
  //       // navigate('/dashboard')
  //     } else if (user_type === 'teacher'&& institute_id) {
  //       // toast.success(response.data.message)
  //       Cookies.set('institute_id', institute_id)
  //       console.log('Institute ID saved in cookie:', institute_id)
  //       setIsLoginSuccessful(false)
  //       navigate('/AssignClass')
  //     }
  //     else if(user_type==="parents"){
  //       setIsLoginSuccessful(false)
  //       navigate("/Student/List")
  //     }
  //   } catch (error) {
  //     console.error('❌ Login failed:', error)
  //     toast.error(error.response?.data?.message || 'Login failed')
  //   }
  // }

  const login = async (loginData) => {
  try {
    const response = await ApiEndpoints.login(loginData)
    const result = response?.data?.result

    if (!result || result === 'User not found') {
      toast.error(response.data.message || 'Login failed')
      return
    }

    const { token, user_type,roles, institute_id } = result
    const userData = { token, user_type,roles, institute_id }
    Cookies.set('user', JSON.stringify(userData))
    Cookies.set('institute_id', institute_id, { expires: 7 })
    Cookies.set('user_type', user_type, { expires: 7 })
    Cookies.set('roles', JSON.stringify(roles),{expires:7})

    setUser(userData)

    toast.success(`${response.data.message}.`)

    if (user_type === 'admin') {
      setIsLoginSuccessful(true) // open modal
    }
  } catch (error) {
    toast.error(error.response?.data?.message || 'Login failed')
  }
}


  const logout = () => {
    console.log('🚪 Logging out...')
    setUser(null)
    Cookies.remove('user')
    Cookies.remove('institute_id')
    Cookies.remove('institute_name')
    Cookies.remove('user_type')
    Cookies.remove('roles')
    toast.success('Logged out successfully!')
    navigate('/LoginSignup', { replace: true })
  }

  useEffect(() => {
    if (isLoginSuccessfull && user?.user_type === 'admin') {
      navigate(window.location.pathname, { replace: true })
    }
  }, [isLoginSuccessfull, user])

  const signUp = async (signupData) => {
    try {
      const response = await ApiEndpoints.signUp(signupData)
      toast.success(response.data.message)
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    } catch (error) {
      const errorMessage = error.response?.data?.message

      if (errorMessage?.includes('Duplicate entry')) {
        toast.error('Email already exists. Please use a different email.')
      } else {
        toast.error(errorMessage || 'Signup failed')
      }
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        token:user?.token,
        institute_id:user?.institute_id,
        roles:user?.roles,
        user_type:user?.user_type,
        login,
        signUp,
        logout,
        courses,
        setCourses,
        classes,
        setClasses,
        students,
        setStudents,
      }}
    >
      {loading ? (
        <div>Loading...</div>
      ) : isLoginSuccessfull && user?.user_type === 'admin' ? (
        <InstituteSelectionModal onClose={() => setIsLoginSuccessful(false)} />
      ) : (
        <>{children}</>
      )}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
